import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import PrivateRoute from "./containers/PrivateRoute";
import IndexAdmin from "./containers/IndexAdmin";

import "./sass/Common.scss";
import {Toaster} from "react-hot-toast";

const App = () => (
  <Router>
    <div className="main-container">
        <Toaster />
      <PrivateRoute path="/admin" component={IndexAdmin} />
    </div>
  </Router>
);

export default App;
